import React, { useEffect, useMemo } from 'react';
import { ConfigProvider } from 'antd';
import { useUserPreferences } from '@/contexts/UserPreferencesContext';
import { getLanguage } from './languageRegistry';
import { getAntdLocale } from './antdLocales';
import { changeAppLanguage, initI18n } from './i18n';
import { nobleAntdTheme } from '@/theme/antd-theme-override';

initI18n('en');

/**
 * Bridges user ui_language → i18next + Ant Design ConfigProvider locale/direction.
 * Must sit inside UserPreferencesProvider and wrap the app tree that uses Ant Design.
 */
export const LocaleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { preferences } = useUserPreferences();
  const lang = getLanguage(preferences.ui_language || preferences.language);

  useEffect(() => {
    void changeAppLanguage(lang.code);
  }, [lang.code]);

  const antdLocale = useMemo(() => getAntdLocale(lang.code), [lang.code]);

  return (
    <ConfigProvider theme={nobleAntdTheme} locale={antdLocale} direction={lang.dir}>
      {children}
    </ConfigProvider>
  );
};

export default LocaleProvider;
